export enum DocumentSubjectMatter {
  'Financial',
  'Legal',
  'Confidential',
}
